export { default } from './side-menu-loader';
